<!-- 个人信息 -->
<template>
	<div class="setting">
		<van-cell title="修改绑定手机号" is-link to="/vascularNews/user/bindNew" size="large" />
		<!-- <van-cell title="关于我们" is-link to="/vascularNews/aboutUs" size="large" /> -->
		<div class="exitBtn" @click="logoutLogin">
			退出登录
		</div>
	</div>
</template>
<script>
	import {} from '../../../config/interface.js'
	export default{
		data(){
			return{
				userInfo:''
			}
		},
		created(){
            if(common.is_weixin()){
                //微信端
				common.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){
					common.getUserInfo();
                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		mounted(){
			// console.log(111)
		},
		methods:{
			//退出登录
			logoutLogin(){
				this.$dialog.confirm({
          message: "确定退出登录？",
        })
          .then(() => {
			  localStorage.removeItem('userInfo');
			  localStorage.removeItem('token');
			  this.$store.dispatch('storageUserInfo',null);
			  this.$router.replace({
				  path:'/vascularNews/user/login'
			  })
		  }).catch()
				
			}
		}
	}
</script>
<style lang="scss">
	.setting{
		background: white;
		font-size:18px;
		.van-cell{
			background: white;
		}
		.exitBtn{
			position: absolute;
			width:100%;
			bottom: 0px;
			left:0px;
			height:50px;
			line-height:50px;
			text-align: center;
			color:$color-main;
			font-size:18px;
			letter-spacing:1px;
			background: rgb(255, 231, 231);
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Personal/Setting.vue